<template>
    <div>
        <div>
            <span v-if="tincan"> Current File </span>
            <button @click="openRemoveTincanModal(current_lesson)" :disabled="!current_lesson.has_tincan[selected_language.key]" :class="{ 'input-disabled button red-content mb-0' : !current_lesson.has_tincan[selected_language.key], 'button red-content mb-0': current_lesson.has_tincan[selected_language.key]}">	            				
                <img width="11" src="../../../assets/images/icons/solid/times_white.svg" />
            </button>
            <button :disabled="!current_lesson.has_tincan[selected_language.key]" :class="{ 'input-disabled button  mb-0' : !current_lesson.has_tincan[selected_language.key], 'button  mb-0': current_lesson.has_tincan[selected_language.key]}">
                <a :href="current_lesson.tincan_url[selected_language.key]" target="_blank">
                <img width="15" src="../../../assets/images/icons/solid/eye_white.svg" />
                </a>
            </button>
            <button :disabled="!current_lesson.has_tincan[selected_language.key]" :class="{ 'input-disabled button mb-0' : !current_lesson.has_tincan[selected_language.key], 'button mb-0': current_lesson.has_tincan[selected_language.key]}">
                    <a :href="current_lesson.tincan_download_url[selected_language.key]">
            <img width="15" src="../../../assets/images/icons/solid/download_white.svg" />
            </a>
            </button>
        </div>
       
    </div>
</template>
<script>
export default{
    props:['current_lesson','tincan','selected_language'],
    data: function(){
        return{
            show_modal_delete_tincan:false
        }
    },
    methods : {
       openRemoveTincanModal: function(current_lesson){
           this.$emit('openRemoveTincanModal',current_lesson)
       }
    }
}

</script>


// WEBPACK FOOTER //
// src/components/sme/SharedViews/LessonFileView.vue